export default __webpack_public_path__ + "static/media/right_answer.33039f0d.mp3";